import { useEffect } from "react";
const INFIX = process.env.NODE_ENV === "production" ? "" : " – DEV ";
export default function useTitle(title) {
    useEffect(() => {
        if (title) {
            document.title = title + INFIX + (title.match(/Igor\s*$/) ? "" : " – Igor");
        }
    }, [title]);
}
